import { render, staticRenderFns } from "./FlightTemplateQuo.vue?vue&type=template&id=2b615a7c&scoped=true&"
import script from "./FlightTemplateQuo.vue?vue&type=script&lang=js&"
export * from "./FlightTemplateQuo.vue?vue&type=script&lang=js&"
import style0 from "./FlightTemplateQuo.vue?vue&type=style&index=0&id=2b615a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b615a7c",
  null
  
)

export default component.exports